import { useEffect } from "react";

import { useDispatch } from "react-redux";
import {
	useLocation,
	useNavigate
} from "react-router-dom";

import { APP_CONSTANTS } from "../../config/appConstants";
import { CookieUtils } from "../../../shared/utils";
import Home from "../../../features/emailVerification/pages/home/Home";
import {
	setParams
} from "../../../features/emailVerification/slices/verificationActionSlice";

const RedirectHandler = () => {
	const dispatch = useDispatch();
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const searchParams = new URLSearchParams(location.search);

		const caseID = searchParams.get(
			APP_CONSTANTS.STORAGE_CONSTANTS.VID
		);
		const sid = searchParams.get(
			APP_CONSTANTS.STORAGE_CONSTANTS.SOURCE_ID
		);
		const result = searchParams.get(
			APP_CONSTANTS.STORAGE_CONSTANTS.SCENARIO_DECLINE
		);

		if (caseID) {
			CookieUtils.setCookie(
				APP_CONSTANTS.STORAGE_CONSTANTS.CASE_ID,
				caseID
			);
		}
		if (sid) {
			CookieUtils.setCookie(
				APP_CONSTANTS.STORAGE_CONSTANTS.SOURCE_ID,
				sid
			);
		}

		dispatch(setParams({ result }));

		// redirect zu cleaner URL
		setTimeout(() => {
			navigate(APP_CONSTANTS.URL.HOME, {
				replace: true
			});
		}, 0);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.search, navigate]);

	return <Home />;
};

export default RedirectHandler;
